import React from "react";
import RegularTaskManager from "./RegularTaskManager";

export default function RegularTaskMedical() {
  return <RegularTaskManager variant="MEDICAL" />;
}
